import { render, staticRenderFns } from "./comp1.vue?vue&type=template&id=7e7efc81&scoped=true"
import script from "./comp1.vue?vue&type=script&lang=ts"
export * from "./comp1.vue?vue&type=script&lang=ts"
import style0 from "./comp1.vue?vue&type=style&index=0&id=7e7efc81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7efc81",
  null
  
)

export default component.exports